import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Model from "../Model";
import {
    CancelBtn,
    InputGroup,
    Label,
    SideCancelBtn,
    SubmitBtn,
} from "../Styles/InputStyles";

const AddExtraBed = ({
    setIsExtraBed,
    selectedData,
    addExtraBedLoading,
    addExtraBedMutate,
}) => {
    const currentBedCount = selectedData?.beds?.length || 0;
    const maxAllowed = 7 - currentBedCount;

    const initialValues = {
        bedCount: "",
        id: selectedData?.id,
    };

    const validationSchema = Yup.object({
        bedCount: Yup.number()
            .required("Bed count is required")
            .min(1, "At least 1 bed must be added")
            .max(
                maxAllowed,
                `Maximum ${maxAllowed} beds allowed (${currentBedCount} existing)`
            ),
    });

    const handleAddExtraBedSubmit = (values) => {
        addExtraBedMutate({
            roomId: selectedData.id,
            bedCount: values.bedCount,
        });
    };

    return (
        <Model
            width={"w-full max-w-md"}
            setOpenModel={setIsExtraBed}
            title="Add Extra Bed"
        >
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleAddExtraBedSubmit}
                enableReinitialize
            >
                {() => (
                    <Form>
                        <InputGroup>
                            <Label>Bed Count *</Label>
                            <Field
                                type="number"
                                name="bedCount"
                                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter Bed Count"
                            />
                            <ErrorMessage
                                name="bedCount"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                            />
                            {currentBedCount > 0 && (
                                <div className="text-gray-500 text-sm mt-1">
                                    Current beds: {currentBedCount} (You can add up to {maxAllowed} beds)
                                </div>
                            )}
                        </InputGroup>

                        <div className="w-full flex justify-between space-x-6 mt-8">
                            <SideCancelBtn onClick={() => setIsExtraBed(false)}>
                                Cancel
                            </SideCancelBtn>
                            <SubmitBtn
                                type="submit"
                                disabled={addExtraBedLoading}
                            >
                                {addExtraBedLoading ? "Submitting..." : "Submit"}
                            </SubmitBtn>
                        </div>
                    </Form>
                )}
            </Formik>
        </Model>
    );
};

export default AddExtraBed;
